import { useLiveQuery } from "@tanstack/react-db";
import type { Property } from "@/lib/collections/properties";
import { propertiesCollection } from "@/lib/collections/properties";

/** Every property row currently in the local (synced) DB, unfiltered. */
export function useAllProperties(): Property[] {
  const { data = [] } = useLiveQuery(
    (q) => q.from({ p: propertiesCollection }).select(({ p }) => p),
    []
  );
  return data;
}
